import { render, staticRenderFns } from "./InternFileManager.vue?vue&type=template&id=788d5d20"
import script from "./InternFileManager.vue?vue&type=script&lang=js"
export * from "./InternFileManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports